import { NextQuery } from '@empathy/search-types';
import { EmpathizeState, EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class NextQueriesSuggestionsGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.nextQueriesSuggestions]:
      (localState: EmpathizeState, getters: any, rootState: RootStoreState, rootGetters: any): NextQuery[] => {
        if (!rootState.core.dirtyInput) {
          const { nextQueriesSuggestions: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
          const sessionQueryHistory: string[] = rootState.history.sessionQueryHistory;

          const nextQueriesSuggestions = config.filterBySessionQueryHistory
            ? rootState.querySignals.nextQueries.filter(nextQuery =>
              !sessionQueryHistory.includes(nextQuery.query))
            : rootState.querySignals.nextQueries;

          return nextQueriesSuggestions.slice(0, config.size);
        } else {
          return [];
        }
      }
  };
}
